import {
  BackgroundVariant,
  OrbVariant,
  PaddingOption,
  WidthOption,
} from '@/lib/CustomBackgroundTypes';

export interface StrapiDisplayOptions {
  PaddingTop?: string;
  PaddingBottom?: string;
  PaddingInline?: string;
  CenterAlignTitles?: boolean;
  CenterAlignParagraphs?: boolean;
  CenterAlignImages?: boolean;
  ContentsWidth?: string;
}

export interface StrapiBackgroundOptions {
  BackgroundColor?: string;
  BackgroundOrbs?: string;
  BackgroundOrbsOverflow?: boolean;
  AnimateOrbs?: boolean;
  FadeInOutContent?: boolean;
  ContainedBackground?: boolean;
}

export function mapDisplayOptions(
  displayOptions?: StrapiDisplayOptions,
  backgroundOptions?: StrapiBackgroundOptions
) {
  return {
    // Map padding options with defaults
    specifiedPaddingTop: mapPaddingOption(displayOptions?.PaddingTop),
    specifiedPaddingBottom: mapPaddingOption(displayOptions?.PaddingBottom),
    specifiedPaddingInline: mapPaddingOption(displayOptions?.PaddingInline),

    // Map alignment options with defaults
    centerAlignTitles: displayOptions?.CenterAlignTitles ?? false,
    centerAlignParagraphs: displayOptions?.CenterAlignParagraphs ?? false,
    centerAlignImages: displayOptions?.CenterAlignImages ?? false,

    // Map width option with default
    width: mapWidthOption(displayOptions?.ContentsWidth),

    // Map background options with defaults
    containedBackground: backgroundOptions?.ContainedBackground ?? false,
    variant: mapBackgroundVariant(backgroundOptions?.BackgroundColor),
    orbVariant: mapOrbVariant(backgroundOptions?.BackgroundOrbs),
  };
}

function mapPaddingOption(padding?: string): PaddingOption {
  switch (padding) {
    case 'xs':
      return 'xs';
    case 'sm':
      return 'sm';
    case 'md':
      return 'md';
    case 'lg':
      return 'lg';
    case 'xl':
      return 'xl';
    case 'none':
    default:
      return 'none';
  }
}

function mapWidthOption(width?: string): WidthOption {
  switch (width) {
    case 'narrow':
      return 'narrow';
    case 'standard':
      return 'standard';
    case 'wide':
      return 'wide';
    // GraphQL sanitizes the enum value's hyphen to an underscore on the wire.
    case 'extra_wide':
      return 'extra-wide';
    default:
      return 'standard';
  }
}

function mapBackgroundVariant(color?: string): BackgroundVariant {
  if (!color) return 'none';

  // Convert underscores to hyphens for consistency
  const normalizedColor = color.replace(/_/g, '-');

  // Type cast to BackgroundVariant - this is safe since we validate the input
  return normalizedColor as BackgroundVariant;
}

function mapOrbVariant(orbs?: string): OrbVariant {
  if (!orbs) return 'none';

  // Convert underscores to hyphens for consistency
  const normalizedOrbs = orbs.replace(/_/g, '-');

  // Type cast to OrbVariant - this is safe since we validate the input
  return normalizedOrbs as OrbVariant;
}
